import { orgUsersById } from 'app/modules/user/selectors'
import { createSelector } from 'reselect'

export const root = state => state.get('hubspot')

export const getAttributeMappings = state => root(state).hubspotAttributeMappings

export const getAttributeFields = state => root(state).hubspotAttributeFields

export const didAttributePatchErr = state => root(state).hubspotAttributeMappingsErr

export const isAttributePatchLoading = state => root(state).hubspotAttributePatching

export const getUserMappings = state => root(state).hubspotUserMappings

export const getHubspotUsers = state => root(state).hubspotUsers

export const isUserMappingLoading = state => root(state).hubspotUserMappingLoading

export const isUserMappingLoaded = state => root(state).hubspotUserMappingLoaded

export const isHubspotUsersSearchLoading = state => root(state).hubspotUsersSearchLoading

export const isHubspotUsersSearchLoaded = state => root(state).hubspotUsersSearchLoaded

export const getHubspotByEmail = (state, email) => root(state).hubspotResponse[email]

export const isAllowAttributeDefaults = createSelector(
  root,
  root => root.allowAttributeDefaults
)

export const isUseCountryAcronyms = createSelector(
  root,
  root => root.useCountryAcronyms
)

export const isUseStateAcronyms = createSelector(
  root,
  root => root.useStateAcronyms
)

export const makeGetHubspotByEmail = () => createSelector(
  getHubspotByEmail,
  (hubSpotEnrichment) => hubSpotEnrichment
)



// WEBPACK FOOTER //
// ./src/scripts/app/modules/hubspot/selectors.js